import React from "react";
import $ from "jquery";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import { InitiateProcessAction } from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import * as CommonFunctions from "../functions/commonFunctions";
import * as GC from "../../../../common/common";
import { StartActionActivity } from "../../../../../api/omnimap/omnimapApi";
import { CAT_WP_CONST } from "../../../../../constants/ActionEnums/CatActionEnums";
import { GetSelected } from "../../../../common/tableHandler/manipulateTable";

class ToevoegenUitvoerder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async hadleSubmit() {
    $("#cover-spin").show(0);

    //** save uitvoerder
    var uitvoerderorganisatieIdentificationModel =  [] ;
    var toezichthouder = $("input[name=uitvoerder]:checked");
    if (toezichthouder.length > 0 || true) {
      for (let i = 0; i < toezichthouder.length; i++) {
        uitvoerderorganisatieIdentificationModel.push(toezichthouder[i].id);
      }

      
    const model = {
      action: CAT_WP_CONST.SELECT_PERFORMERS,
      uitvoerderorganisatie_identification: uitvoerderorganisatieIdentificationModel,
      identifications: GetSelected()
    }
    InitiateProcessAction(model, CAT_WP_CONST.END_POINT).then(()=>{
      this.submitCallback()
    }).catch(()=>{
      alert('Something went wrong!')
      $("#cover-spin").hide(0);
    })


      // await GC.StartActivity(
      //   uitvoerderModel,
      //   [window.$catalog_work_plans_selectedIds],
      //   "c2c28e89-63ee-4714-8051-4b425f2c0976",
      //   this.submitCallback,
      //   window.$catalog_management_units_token
      // );
    } /* else {
      window.$catalog_work_plans_selectedIds.forEach(async (id) => {
        let realtions = await omnimap.GetRelationAction(
          id,
          1,
          30,
          window.$catalog_management_units_token
        );
        await realtions.data.forEach(async (relation) => {
          if (relation.role === "Uitvoerder") {
            await omnimap
              .DeleteRelationAction(
                relation.identification,
                window.$catalog_management_units_token
              )
              .catch((error) => {
                console.log(error);
              });
          }
        });
      });
      this.submitCallback();
    }*/
  }
  submitCallback() {
    GC.sleep(1000).then(() => {
      $("#toevoegen_uitvoerder").modal("hide");
      $("#cover-spin").hide(0);
    });
  }
  async componentDidMount() {
    var that = this;

    $("#toevoegen_uitvoerder").on("show.bs.modal", async (event) => {
      let userRegisteredRoles = await omnimap.GetRelationAction(
        window.$catalog_work_plans_selectedIds[0],
        1,
        30,
        window.$catalog_management_units_token
      );

      omnimap
        .GetUserByRoleAction(
          1,
          30,
          "uitvoerder",
          window.$catalog_management_units_token
        )
        .then((result) =>
          CallBackFunctions.ToevoegenToezichthouderCallbackForCreate(
            result,
            userRegisteredRoles.data,
            "toevoegen-uitvoerder",
            "uitvoerder"
          )
        );
    });
  }

  render() {
    return (
      <div>
        <div
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          id="toevoegen_uitvoerder"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Toevoegen uitvoerder(s)</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {/* //** Toevoegen uitvoerder(s)  */}
                <div className="modal-scroll">
                  {" "}
                  <label>Uitvoerders </label>
                  <div id="toevoegen-uitvoerder" className="radio-grp" />
                </div>
                <br />
                <br />
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="save-werkplann"
                  className="btn-modal"
                  onClick={this.hadleSubmit.bind(this)}
                >
                  Verwerken
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ToevoegenUitvoerder;
